import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { getLinkByParams } from 'utils/embeddableItems.utils'

@observer
class Banner extends Component {
  render() {
    const {
      productLink,
      productLink: { name, embedPrefs, product },
    } = this.props
    return (
      <div>
        <a target='blank' href={getLinkByParams(productLink, product)}>
          {embedPrefs.banner && <img src={embedPrefs.banner} alt={name} style={{ maxWidth: '100%' }} />}
        </a>
      </div>
    )
  }
}

export default Banner
